/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { routes } from "@bvi/admin-panel/api-routes";
import { apiContainer, getItemTags, getListTag, invalidateTags, provideTagsList, TagTypes, WithId } from "@bvi/admin-panel/shared/api";
import { getResponseData } from "@bvi/api-interfaces/response";
import {
  IDamageListResponse,
  IDamageResponse
} from '@bvi/api-interfaces/response/manage-base-data';
import { ICreateDamageRequest } from "@bvi/api-interfaces/request/damage";

export const damageApi = apiContainer.injectEndpoints({
  endpoints: (builder) => ({
    getDamageList: builder.query<IDamageListResponse, void>({
      query: () => ({
        url: routes.damage.findAll(),
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
            ...getItemTags(TagTypes.DAMAGE, getResponseData(result)),
            getListTag(TagTypes.DAMAGE),
          ]
          : [getListTag(TagTypes.DAMAGE)],
    }),

    getByIdDamage: builder.query<IDamageResponse, number>({
      query: (id) => ({
        url: routes.damage.findOne(),
        method: 'GET',
        params: { id },
      }),
      providesTags: provideTagsList(TagTypes.DAMAGE)
    }),

    createDamage: builder.mutation<
      IDamageResponse,
      ICreateDamageRequest
    >({
      query: (data) => ({
        url: routes.damage.create(),
        method: 'POST',
        data,
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.DAMAGE)),
    }),

    updateDamage: builder.mutation<
      IDamageResponse,
      WithId<ICreateDamageRequest>
    >({
      query: ([id, data]) => ({
        url: routes.damage.update(),
        method: 'PUT',
        data: { id, name: data.name },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.DAMAGE)),
    }),

    deleteDamage: builder.mutation<void, number>({
      query: (id) => ({
        url: routes.damage.remove(),
        method: 'DELETE',
        params: { id },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.DAMAGE)),
    }),
  }),
});

export const {
  useGetDamageListQuery,
  useLazyGetDamageListQuery,
  useGetByIdDamageQuery,
  useLazyGetByIdDamageQuery,
  useCreateDamageMutation,
  useUpdateDamageMutation,
  useDeleteDamageMutation
} = damageApi;

